import React, { FC } from 'react'

import { TextLinkProps } from '../A'
import Tag from '../Tag'

import * as SC from './styled'

export type TagProps = TextLinkProps & {
  isActive?: boolean
}

export type TagsProps = {
  className?: string
  tags?: TagProps[]
  color?: string
}

const Tags: FC<TagsProps> = (props) => {
  const { className, tags, color } = props

  return (
    <SC.Container className={className}>
      <SC.List>
        {tags?.map((tag, index) => (
          <li key={`${index}`}>
            <Tag backgroundColor={color} {...tag} />
          </li>
        ))}
      </SC.List>
    </SC.Container>
  )
}

export default Tags
